export enum EmojiIcon {
    Apartment = 'emoji-apartment',
    WomanRaisingHand = 'emoji-woman-raising-hand',
    House = 'emoji-house',
    NewHouse = 'emoji-new-house',
    OldHouse = 'emoji-old-house',
    SingleMeter = 'emoji-single-meter',
    Sun = 'emoji-sun',
    NightMoon = 'emoji-night-moon',
    WomanDontKnow = 'emoji-woman-dont-know',
    MobilePhone = 'emoji-mobile-phone',
    FixedLine = 'emoji-fixed-line',
    Closed = 'emoji-closed',
    HalfOpen = 'emoji-half-open',
    Post = 'emoji-post',
    Water = 'emoji-water',
    Dashboard = 'emoji-dashboard',
    Rocket = 'emoji-rocket',
    Male = 'emoji-male',
    Female = 'emoji-female',
    Art = 'emoji-art',
    Checkbox = 'emoji-checkbox',
    Cancel = 'emoji-cancel',
}
